var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54293 45.8869C6.33777 45.842 6.1326 45.7926 5.92629 45.7511C2.42817 45.0507 0.0269351 42.2097 0.0189118 38.61C-0.00630395 28.1713 -0.00630395 17.7325 0.0189118 7.29368C0.0257889 3.69398 2.41327 0.840715 5.91368 0.148163C6.42197 0.05168 6.93869 0.00431045 7.45643 0.0067347C14.8683 -0.0022449 22.2803 -0.0022449 29.6922 0.0067347C33.2694 0.0067347 36.1211 2.20112 36.9578 5.60103C37.0889 6.18366 37.1516 6.77905 37.1446 7.37562C37.1606 10.9001 37.1549 14.4246 37.1515 17.948C37.1515 19.0177 36.6804 19.6833 35.7841 19.9201C35.5375 19.986 35.2793 19.9996 35.0269 19.9599C34.7745 19.9203 34.5336 19.8283 34.3204 19.6902C34.1072 19.552 33.9266 19.3709 33.7906 19.1589C33.6546 18.947 33.5664 18.709 33.5319 18.4609C33.5028 18.2241 33.4898 17.9856 33.4929 17.7471C33.4929 14.3124 33.4929 10.8777 33.4929 7.44297C33.4929 5.88837 32.8797 4.67164 31.4298 3.98694C30.8915 3.73991 30.305 3.61009 29.7105 3.60643C22.2848 3.58174 14.8588 3.578 7.43236 3.59521C5.33257 3.59521 3.83567 5.00613 3.68666 7.05348C3.6752 7.21736 3.67062 7.38123 3.67062 7.54511C3.67062 17.82 3.66871 28.0946 3.66489 38.3687C3.66489 39.957 4.24486 41.2119 5.73488 41.91C6.30405 42.1565 6.91892 42.2857 7.54124 42.2894C9.48974 42.3355 11.4451 42.3018 13.397 42.3096C14.165 42.3096 14.7541 42.6464 15.0865 43.3311C15.3994 43.9776 15.3558 44.6365 14.8779 45.1775C14.6131 45.4772 14.2062 45.6579 13.8635 45.8914L6.54293 45.8869Z",
    fill: "url(#paint0_linear_76_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.277 45.8867C21.2316 45.8519 21.1829 45.8214 21.1315 45.7958C20.1263 45.4018 19.6495 44.5432 19.9532 43.533C20.6539 41.2027 21.3768 38.8789 22.1218 36.5614C22.2505 36.2115 22.4599 35.8953 22.7338 35.6376C26.0035 32.4199 29.2834 29.2124 32.5737 26.0149C34.1474 24.4906 36.0443 23.9945 38.1636 24.6489C40.245 25.2943 41.5081 26.7366 41.9024 28.8345C42.2096 30.4631 41.7878 31.9448 40.6943 33.2244C40.4651 33.4983 40.1969 33.7497 39.9379 34.0022C36.8424 37.0306 33.7478 40.0593 30.6539 43.0885C30.2477 43.4928 29.7377 43.7824 29.1776 43.9269C26.7855 44.5679 24.4004 45.2312 22.0129 45.8867H21.277ZM24.4015 41.4968C25.5832 41.1769 26.6572 40.8986 27.7254 40.5888C27.9832 40.5124 28.2188 40.3774 28.4131 40.1948C30.4609 38.2103 32.5011 36.2176 34.5337 34.2166C34.6368 34.1156 34.7308 34.0056 34.8065 33.9237L32.2516 31.4139C32.2012 31.4554 32.129 31.507 32.066 31.5688C29.9371 33.6453 27.8098 35.7233 25.6841 37.8028C25.6011 37.8681 25.5345 37.951 25.4892 38.0453C25.1293 39.1644 24.7809 40.2868 24.4015 41.4968ZM37.4679 31.3207C38.1556 30.792 38.488 30.123 38.2599 29.279C38.0627 28.5494 37.5355 28.1094 36.7779 27.9904C35.9755 27.8647 35.3818 28.234 34.9153 28.812L37.4679 31.3207Z",
    fill: "url(#paint1_linear_76_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5778 10.7556C21.6873 10.7556 24.798 10.7489 27.9088 10.7556C29.2842 10.7613 30.1724 11.9735 29.7002 13.1712C29.4217 13.8794 28.8738 14.2588 28.1059 14.3284C27.8767 14.3486 27.6474 14.3374 27.4182 14.3374C21.3954 14.3374 15.3727 14.3374 9.34993 14.3374C8.11321 14.3374 7.27536 13.5517 7.33038 12.464C7.38081 11.4662 8.15677 10.7601 9.24334 10.7568C11.6835 10.7478 14.1226 10.7568 16.5628 10.7568L18.5778 10.7556Z",
    fill: "url(#paint2_linear_76_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5641 21.5092C15.4694 21.5092 12.3747 21.5092 9.28006 21.5092C8.03302 21.5092 7.20892 20.6258 7.35105 19.4764C7.40205 19.0807 7.58846 18.7136 7.87987 18.435C8.17128 18.1563 8.5505 17.9826 8.95569 17.9421C9.09244 17.9293 9.22984 17.9245 9.36717 17.9275C15.5114 17.9275 21.656 17.9275 27.8011 17.9275C29.0194 17.9275 29.8435 18.6829 29.8183 19.7616C29.7954 20.7538 29.016 21.4969 27.942 21.507C26.6159 21.5204 25.2886 21.507 23.9625 21.507L18.5641 21.5092Z",
    fill: "url(#paint3_linear_76_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8652 28.6798C12.9912 28.6798 11.1172 28.6854 9.24898 28.6798C8.2564 28.6798 7.49648 28.0658 7.36238 27.1937C7.18587 26.0443 8.0008 25.1082 9.21803 25.1014C11.4726 25.088 13.7271 25.1014 15.9805 25.1014C17.5198 25.1014 19.0579 25.0913 20.5961 25.1071C21.0116 25.1038 21.4155 25.2406 21.7402 25.4944C22.065 25.7482 22.2907 26.1037 22.3795 26.5011C22.5583 27.3598 22.1411 28.2017 21.3319 28.5216C21.0334 28.6299 20.7173 28.6847 20.399 28.6832C18.5513 28.6865 16.7083 28.6798 14.8652 28.6798Z",
    fill: "url(#paint4_linear_76_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_3",
    x1: 18.5777,
    y1: 0,
    x2: 18.5777,
    y2: 45.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_3",
    x1: 30.9313,
    y1: 24.3668,
    x2: 30.9313,
    y2: 45.8867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_3",
    x1: 18.578,
    y1: 10.7527,
    x2: 18.578,
    y2: 14.3405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_3",
    x1: 18.577,
    y1: 17.9266,
    x2: 18.577,
    y2: 21.5129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76_3",
    x1: 14.8794,
    y1: 25.0955,
    x2: 14.8794,
    y2: 28.6841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteBoard);
export default __webpack_public_path__ + "static/media/note-board.6935622ba6bc3833274108b2195e6f46.svg";
export { ForwardRef as ReactComponent };